import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { getCourseBatchDetail } from 'src/services/eLearning/detail'

export const fetchCourseBatchDetail = (uuid) => async (dispatch) => {
  dispatch(startLoading())
  await dispatch(getCourseBatchDetail(uuid))
  dispatch(stopLoading())
}
